import { createEpic, createDownloadEpic } from "../helpers";
import {
	getShopsAsyncAction,
	updateShopStatusAsyncAction,
	getShopAsyncAction,
	exportShopDataAsyncAction,
} from "./shopActions";

export const getShopsEpic = createEpic(
	getShopsAsyncAction,
	"shop",
	"getList",
	true
);

export const getShopEpic = createEpic(
	getShopAsyncAction,
	"shop",
	"getDetail",
	true
);

export const updateShopStatusEpic = createEpic(
	updateShopStatusAsyncAction,
	"shop",
	"updateStatus",
	true
);

export const exportPlayersEpic = createDownloadEpic(
	exportShopDataAsyncAction,
	"shop",
	"exportShops",
	true,
	"shops"
);
